import React, { useState, ChangeEvent, FormEvent } from "react";

// Tipamos la respuesta que esperamos de nuestro backend de Node
interface UploadResponse {
  success: boolean;
  videoId?: string;
  url?: string;
  error?: string;
}

export default function UploadShort() {
  const [video, setVideo] = useState<File | null>(null);
  const [title, setTitle] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [shortUrl, setShortUrl] = useState<string>("");

  // Capturar el archivo binario del input
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setVideo(e.target.files[0]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!video) return alert("Selecciona un video");

    setLoading(true);

    const BASE_URL =
      process.env.NODE_ENV === "development"
        ? "http://localhost:5500"
        : "https://ligavirtualf1.es:5500";
    try {
      const response = await fetch(`${BASE_URL}/api/admin/upload-short`, {
        method: "POST",
        body: video, // <-- ENVIAMOS EL ARCHIVO (FILE) DIRECTAMENTE, SIN FORMDATA
      });

      const data = await response.json();
      if (data.success) {
        alert("¡Subido!");
      } else {
        alert("Error: " + data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "400px",
        margin: "0 auto",
        fontFamily: "sans-serif",
      }}
    >
      <h2>Subir Short (TypeScript)</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "10px" }}>
          <label style={{ display: "block", fontWeight: "bold" }}>
            Título del Short:
          </label>
          <input
            type="text"
            value={title}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setTitle(e.target.value)
            }
            placeholder="Ej: Brutal adelantamiento en Spa #shorts"
            style={{
              width: "100%",
              padding: "8px",
              marginTop: "5px",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div style={{ marginBottom: "10px" }}>
          <label style={{ display: "block", fontWeight: "bold" }}>
            Descripción:
          </label>
          <textarea
            value={description}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
              setDescription(e.target.value)
            }
            placeholder="Detalles de la carrera..."
            style={{
              width: "100%",
              padding: "8px",
              marginTop: "5px",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", fontWeight: "bold" }}>
            Video de la PC:
          </label>
          <input
            type="file"
            accept="video/*"
            onChange={handleFileChange}
            style={{ marginTop: "5px" }}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: loading ? "#ccc" : "#ff0000",
            color: "white",
            border: "none",
            cursor: loading ? "not-allowed" : "pointer",
            fontWeight: "bold",
          }}
        >
          {loading ? "Transmitiendo binario..." : "Publicar Short"}
        </button>
      </form>

      {shortUrl && (
        <div
          style={{
            marginTop: "20px",
            color: "green",
            padding: "10px",
            border: "1px solid green",
            borderRadius: "4px",
          }}
        >
          <p style={{ margin: "0 0 5px 0" }}>🎉 ¡Subido correctamente!</p>
          <a
            href={shortUrl}
            target="_blank"
            rel="noreferrer"
            style={{ wordBreak: "break-all" }}
          >
            {shortUrl}
          </a>
        </div>
      )}
    </div>
  );
}
